var map = {
	"./de/gotoTOPbg.png": "FH63",
	"./en/gotoTOPbg.png": "kawK",
	"./es/gotoTOPbg.png": "YHdB",
	"./fr/gotoTOPbg.png": "A1U2",
	"./ja/gotoTOPbg.png": "K3Uk",
	"./ko/gotoTOPbg.png": "m8a0",
	"./pt/gotoTOPbg.png": "Aw5y",
	"./ru/gotoTOPbg.png": "HTd2",
	"./tc/gotoTOPbg.png": "pxfa",
	"./th/gotoTOPbg.png": "EKh/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vzE5";